import { render } from "./Test.vue?vue&type=template&id=0b69e34a"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/Test.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b69e34a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b69e34a', __exports__)) {
    api.reload('0b69e34a', __exports__)
  }
  
  module.hot.accept("./Test.vue?vue&type=template&id=0b69e34a", () => {
    api.rerender('0b69e34a', render)
  })

}


export default __exports__